import { render } from "./tw-ws-clock.vue?vue&type=template&id=568e6666"
import script from "./tw-ws-clock.vue?vue&type=script&lang=js"
export * from "./tw-ws-clock.vue?vue&type=script&lang=js"
script.render = render

export default script